import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@fontsource/barlow-condensed/latin-600.css";
import "@fontsource/barlow-condensed/latin-700.css";
import "@fontsource/source-sans-3/latin-400.css";
import "@fontsource/source-sans-3/latin-600.css";
import "@fontsource/ibm-plex-mono/latin-400.css";
import "@/styles.css";
import App from "@/App";
import { AuthProvider } from "@/app/auth";
import { ConfirmDialogProvider } from "@/components/ConfirmDialog";
import { ToastProvider } from "@/components/Toast";
const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000, retry: 1 } } });
ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><QueryClientProvider client={queryClient}><ToastProvider><BrowserRouter><ConfirmDialogProvider><AuthProvider><App /></AuthProvider></ConfirmDialogProvider></BrowserRouter></ToastProvider></QueryClientProvider></React.StrictMode>);
